import { render, staticRenderFns } from "./officeViewer.vue?vue&type=template&id=070a2f78"
import script from "./officeViewer.vue?vue&type=script&lang=js"
export * from "./officeViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports